import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import api from "../components/api";
import { Spinner, Table, Badge, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClockRotateLeft,
  faReceipt,
} from "@fortawesome/free-solid-svg-icons";

const Historical = () => {
  const [ordersHistorical, setOrdersHistorical] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/connexion");
      return;
    }

    api
      .get("/user/orders", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data.ordersHistorical || [];
        setOrdersHistorical(data);
      })
      .catch((error) => {
        setErr("Erreur lors de la récupération de votre historique.");
        console.error("Erreur API :", error);
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  // Fonction pour gérer la couleur des badges de statut
  const getStatusBadge = (status) => {
    switch (status) {
      case "Livrée":
        return <Badge bg="success">Livrée</Badge>;
      case "En cours":
        return (
          <Badge bg="warning" text="dark">
            En cours
          </Badge>
        );
      case "En attente":
        return <Badge bg="primary">En attente</Badge>;
      case "Annulée":
        return <Badge bg="danger">Annulée</Badge>;
      default:
        return <Badge bg="secondary">{status || "Inconnu"}</Badge>;
    }
  };

  return (
    <>
      <Header />

      <div className="container mt-5">
        <div className="d-block d-md-none text-start mb-4">
          <Link
            to="/dashboard"
            className="text-decoration-none fw-bold text-orange"
            style={{ color: "#f5721e" }}
          >
            <strong>← Tableau de bord</strong>
          </Link>
        </div>
        <div className="d-flex align-items-center justify-content-center mb-4">
          <FontAwesomeIcon
            icon={faClockRotateLeft}
            className="me-3 text-primary fs-2"
          />
          <h1 className="mb-0 fw-bold">Mon Historique</h1>
        </div>

        {err && (
          <div className="alert alert-danger shadow-sm text-center">{err}</div>
        )}

        {loading ? (
          <div className="text-center mt-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2 text-muted">
              Chargement de vos souvenirs gourmands...
            </p>
          </div>
        ) : (
          <Card className="border-0 shadow-sm rounded-3">
            <div className="table-responsive" style={{ maxHeight: "500px" }}>
              <Table hover align="middle" className="mb-0">
                <thead className="table-primary text-white">
                  <tr>
                    <th className="ps-4">#</th>
                    <th>Menu</th>
                    <th>Date</th>
                    <th className="text-center">Qté</th>
                    <th>Total</th>
                    <th>Localisation</th>
                    <th className="text-center">Statut</th>
                  </tr>
                </thead>
                <tbody>
                  {ordersHistorical.length > 0 ? (
                    ordersHistorical.map((order, index) =>
                      order.order_items.map((item, itemIndex) => (
                        <tr key={`${order.id}-${item.id || itemIndex}`}>
                          <td className="ps-4 text-muted fw-bold">
                            {itemIndex === 0 ? index + 1 : ""}
                          </td>
                          <td>
                            <div className="fw-bold text-dark">
                              {item.menu_item?.name || "N/A"}
                            </div>
                            {itemIndex === 0 && order.notes && (
                              <small className="text-danger italic d-block">
                                Note: {order.notes}
                              </small>
                            )}
                          </td>
                          <td className="small text-muted">
                            {itemIndex === 0
                              ? new Date(order.created_at).toLocaleDateString(
                                  "fr-FR",
                                  {
                                    day: "numeric",
                                    month: "short",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  },
                                )
                              : ""}
                          </td>
                          <td className="text-center">
                            <span className="badge bg-light text-dark border">
                              {item.quantity}
                            </span>
                          </td>
                          <td className="fw-bold">
                            {itemIndex === 0 ? `${order.total_price} FCFA` : ""}
                          </td>
                          <td>
                            {itemIndex === 0 ? (
                              <small className="text-muted">
                                <FontAwesomeIcon
                                  icon={faReceipt}
                                  className="me-1 opacity-50"
                                />
                                {order.localisation}
                              </small>
                            ) : (
                              ""
                            )}
                          </td>
                          <td className="text-center">
                            {itemIndex === 0
                              ? getStatusBadge(order.status)
                              : ""}
                          </td>
                        </tr>
                      )),
                    )
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center py-5 text-muted">
                        Vous n'avez pas encore passé de commande.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card>
        )}
      </div>
    </>
  );
};

export default Historical;
